import actions from 'actions/products/supplierDetails'
import supplierActions from 'actions/suppliers'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import Component from 'components/Products/SupplierDetails/FormView'

export default createChildFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getSuppliers: (params) =>
      dispatch(
        supplierActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
  }),
})(Component)
